"use strict";

var chipsCtrl = [
  "$http",
  "Member",
  "Department",
  "$scope",
  "$state",
  function ($http, Member, Department, $scope, $state) {
    var _this = this;
    this.filterList = JSON.parse(JSON.stringify(this.filter || []));

    this.addUserToList = function (item) {
      var _this = this;
      _this.list.push(item);
      _this.filterList.push(item);
      _this.newUser = "";
    };

    this.removeChip = function (index) {
      var removedUser = _this.list.splice(index, 1);
      _this.filterList = _this.filterList.filter(function (member) {
        return member.id !== removedUser[0].id;
      });
    };

    this.getUsers = function (query) {
      if ($scope.attr.getFrom) {
        return _this
          .getFrom({
            query: query,
          })
          .then(function (data) {
            return data.filter(function (member) {
              if (_this.filterList) {
              }
              for (var i = 0; i < _this.filterList.length; i++) {
                if (_this.filterList[i].id === member.id) {
                  return false;
                }
              }
              return member;
            });
          });
      }

      var search = { filter: { include: ["clients"] } };
      if (query) {
        var nameQuery = query.split(" ");
        nameQuery = nameQuery.map(function transformWord(word) {
          return "(\\b" + word + ")";
        });

        nameQuery = nameQuery.reduce(function reducingQueryToString(
          query,
          reg
        ) {
          if (!query) {
            return reg;
          }
          query = query + "|" + reg;
          return query;
        },
        "");

        search = {
          filter: {
            include: ["clients"],
            where: {
              or: [
                {
                  email: {
                    regexp: "/^" + query + "/gi",
                  },
                },
                {
                  firstName: {
                    regexp: "/" + nameQuery + "/gi",
                  },
                },
                {
                  lastName: {
                    regexp: "/" + nameQuery + "/gi",
                  },
                },
              ],
            },
          },
        };
      }
if($state.params.departmentId ==undefined){
          return Member.find(search).$promise.then(function (data) {
            if (_this.filter) {
              data = data.filter(function (member) {
                for (var i = 0; i < _this.filterList.length; i++) {
                  if (_this.filterList[i].id === member.id) return false;                  
                }
                  return member;
              
              });
            }
            return data.sort((a, b) => (a.lastName??'').localeCompare(b.lastName ?? ''));
          });
        }
else
      return Department.findById({ id: $state.params.departmentId })
        .$promise.then(function (department) {
          return Member.find(search).$promise.then(function (data) {
            if (_this.filter) {
              data = data.filter(function (member) {
                for (var i = 0; i < _this.filterList.length; i++) {
                  if (_this.filterList[i].id === member.id) return false;                  
                }
                if (
                  department == undefined ||
                  department.clientId == undefined ||
                  member.clients.length == 0 ||
                  member.clients.find((clt) => clt.id == department.clientId)
                ) {
                  return member;
                } else return false;
              });
            }
            return data.sort((a, b) => (a.lastName??'').localeCompare(b.lastName ?? ''));
          });
        })
        .catch(function (error) {});
    };
  },
];

module.exports = function () {
  return {
    restrict: "E",
    scope: {
      list: "=",
      filter: "=",
      getFrom: "&",
    },
    controller: chipsCtrl,
    controllerAs: "ctrl",
    bindToController: true,
    templateUrl: "chips-directive/chipsDirective.html",
    link: function (scope, element, attr) {
      scope.attr = attr;
    },
  };
};
